import { useState } from 'react'

export const useConfirmDelete = (
  onDelete: (index: number) => void,
  shouldConfirm: (index: number) => boolean
) => {
  const [indexToDelete, setIndexToDelete] = useState<number | null>(null)

  const requestDelete = (index: number) => {
    if (!shouldConfirm(index)) {
      onDelete(index)
      return
    }

    setIndexToDelete(index)
  }

  const onClose = () => {
    setIndexToDelete(null)
  }

  const onConfirm = () => {
    if (indexToDelete === null) {
      return
    }

    onDelete(indexToDelete)
    setIndexToDelete(null)
  }

  return {
    opened: indexToDelete !== null,
    requestDelete,
    onClose,
    onConfirm
  }
}
